import { useState, useEffect } from 'react';

function useWindowSize() {
  const isClient = typeof window !== 'undefined';

  const [windowSize, setWindowSize] = useState({
    width: isClient ? window.innerWidth : 1024,
    height: isClient ? window.innerHeight : 768,
  });

  const handleResize = () => {
    setWindowSize({ width: window.innerWidth, height: window.innerHeight });
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return windowSize;
}

export default useWindowSize;
